import { isNative } from '@/native/capacitorShell';

const PREF_KEY = 'numuv_biometric_enabled';
const BG_AT_KEY = 'numuv_backgrounded_at';
// Lenient policy: only re-lock if the app sat in the background for longer than this.
export const RELOCK_AFTER_MS = 15 * 60 * 1000;

export const isBiometricEnabled = () => localStorage.getItem(PREF_KEY) === '1';
export const setBiometricEnabled = (on) =>
  on ? localStorage.setItem(PREF_KEY, '1') : localStorage.removeItem(PREF_KEY);

export const markBackgrounded = () => localStorage.setItem(BG_AT_KEY, String(Date.now()));
export const shouldRelock = () => {
  const at = Number(localStorage.getItem(BG_AT_KEY) || 0);
  return at > 0 && Date.now() - at > RELOCK_AFTER_MS;
};
export const clearBackgrounded = () => localStorage.removeItem(BG_AT_KEY);

export async function getBiometryInfo() {
  if (!isNative) return { available: false, label: 'Biometric unlock' };
  try {
    const { BiometricAuth, BiometryType } = await import('@aparajita/capacitor-biometric-auth');
    const info = await BiometricAuth.checkBiometry();
    const labels = {
      [BiometryType.faceId]: 'Face ID',
      [BiometryType.touchId]: 'Touch ID',
      [BiometryType.fingerprintAuthentication]: 'Fingerprint',
      [BiometryType.faceAuthentication]: 'Face unlock',
      [BiometryType.irisAuthentication]: 'Iris unlock',
    };
    return {
      available: !!info.isAvailable,
      label: labels[info.biometryType] || 'Biometric unlock',
    };
  } catch (_) {
    return { available: false, label: 'Biometric unlock' };
  }
}

export async function verifyBiometric(reason = 'Unlock Numuv') {
  if (!isNative) return false;
  const { BiometricAuth } = await import('@aparajita/capacitor-biometric-auth');
  await BiometricAuth.authenticate({
    reason,
    cancelTitle: 'Use password',
    allowDeviceCredential: true,
    iosFallbackTitle: 'Use passcode',
    androidTitle: 'Unlock Numuv',
    androidSubtitle: reason,
    androidConfirmationRequired: false,
  });
  return true;
}
